/**
 * Created by FLI on 2015-02-09.
 */
angular.module('ffApp').controller('ContactController', ['$scope', '$http', function($scope, $http)
{
	$scope.opening = false;
	$scope.closing = false;
	$scope.opened = false;
	$scope.submitting = false;

	$scope.open = function()
	{
		if( $scope.opening )
		{
			return;
		}
		$scope.opening = true;

		navmenu.close();
		jQuery(".page-viewport").toggleClass( "blur" );
		jQuery(".contact-dim-content").removeClass('hidden').switchClass( "transparent", "opaque", 400 );
		jQuery(".contact-container").removeClass('hidden').switchClass( "transparent", "opaque", 400 );
		jQuery("#menu-button-open").fadeOut(400);

		//Handle accidental double-taps
		setTimeout(function(){ $scope.opening = false; $scope.opened = true; },400);
	};

	$scope.back = function()
	{
		$scope.close();
		setTimeout(function(){ navmenu.open(); },400);
	};

	$scope.close = function()
	{
		if( $scope.closing )
		{
			return;
		}

		var $container = jQuery(".contact-container");
		var $form = $container.find("form");

		$scope.closing = true;
		jQuery(".page-viewport").toggleClass( "blur" );
		jQuery(".contact-dim-content").switchClass( "opaque", "transparent", 400, "swing", function(){ jQuery(".contact-dim-content").addClass('hidden'); } );
		$container.switchClass( "opaque", "transparent", 400, "swing", function(){ jQuery(".contact-container").addClass('hidden'); } );
		jQuery("#menu-button-open").fadeIn(400);

		//Handle accidental double-taps
		setTimeout(function()
		{
			$scope.closing = false;
			$scope.opened = false;
			$form.find(".input-holder, button[type='submit']").show();
			$form.find(".message").hide().children().hide();
			$form.find("button.close").hide();
		},400);
	};

	$scope.submit = function( isValid )
	{
		if( ! isValid || $scope.submitting ) {
			return false;
		}
		$scope.submitting = true;

		var $form = jQuery('form[name="contactForm"]');

		var data = {
			action: 'contact_form_message',
			name: $scope.name,
			email: $scope.email,
			message: $scope.message
		};

		$form.find(".message").show();
		$form.find(".message").find(".sending").show();

		jQuery.post(ajaxUrl, data, function(response, status, xhr)
		{

			$form.find(".message").find(".sending").hide();

			if( response == "ok" )
			{
				//Hide form
				$form.find(".input-holder, button[type='submit']").hide();
				//Clear data
				$scope.name = "";
				$scope.email = "";
				$scope.message = "";
				//Show message and close button

				$form.find(".message").find(".sent").show();
				$form.find("button.close").show();
			}
			else
			{
				$form.find(".message").find(".error.general").show();
				setTimeout(function()
				{
					$form.find(".message").hide().find(".error.general").hide();
				},5000);
			}

			$scope.submitting = false;
		});
	};
}]);
